export const CLASS_NAMES = {
	agentCard:
		'flex min-h-[58px] w-full flex-col gap-4 rounded-xl bg-white px-4 py-4 shadow-none sm:flex-row sm:items-center sm:justify-between sm:px-5 sm:py-3',
	agentAvatar:
		'h-16 w-16 flex justify-center rounded-full overflow-hidden bg-[#F9D7E3]',
	agentNameRow:
		'flex items-center gap-1 text-xl font-bold text-[var(--color-primary-900)]',
	profileMeta: 'font-normal leading-6 text-[var(--color-primary-900)]'
} as const;
